// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".RelatedPapersSidebar-cls1___f39d4618dd07852089b{/*!*/}.RelatedPapersSidebar-cls2___7253161d201fa6e5a1f{display:flex;flex-direction:row;grid-gap:24px;gap:24px;grid-gap:var(--spacing-sm-24, 24px);gap:var(--spacing-sm-24, 24px)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "RelatedPapersSidebar-cls1___f39d4618dd07852089b",
	"cls2": "RelatedPapersSidebar-cls2___7253161d201fa6e5a1f RelatedPapersSidebar-cls1___f39d4618dd07852089b"
};
export default ___CSS_LOADER_EXPORT___;
